import request from "../request"
import cookie from "js-cookie";
//查询标头树
export function getNavTopTree() {
  if(cookie.get("lang")=="en"){
    let data={
      cType:2,
    }
    return request({
      url: '/columns/',
      method:'get',
      params:data
    })
  }else{
    let data={
      cType:1,
    }
    return request({
      url: '/columns/',
      method:'get',
      params:data
    })
  }

 }

 //查询天气数据
export function getWeatherData() {
  let data = {
    district_id:'530100',
    data_type:'now',
    ak:'ExdkBfVR7NTcNoLFiqwIQUx42r9yUIez',
    }
  return request({
    url: '/weather/',
    method:'get',
    params:data
  })
}



// WEBPACK FOOTER //
// ./src/api/navtop.js